import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Link from '@material-ui/core/Link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import { WithStyles, withStyles } from '@material-ui/core/styles';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link as RouterLink, match, RouteComponentProps } from 'react-router-dom';
// Components
import { Anchor } from '../../../components/anchor';
// import { AnchorBlock } from '../../../components/anchorBlock';
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import { AutoFill } from '../../../components/field-autofill';
import { FormatType, FormPickerDatas, ViewEditCell, ActionFunction } from '../../../local-types';
import { TooltipButton } from '../../../components/tooltip-button';
import { Typobold } from '../../../components/typobold';
import { LCAlert } from '../../../components/alert';
import { ActionLogs } from '../../../components/action-logs';
import FormSubmit from '../../../components/form/formSubmit';
// Modules
import {
    Rider,
    RiderById,
    CompanyMembership,
    AccountType,
    RiderNew,
    Membership,
    CompanyById,
    TParams,
} from '../../../redux/reducers/api-types';
import {
    ErrorPayload,
    actions as errorActions,
    editRiderErrorTypes,
    selectors as errorSelectors,
} from '../../../redux/reducers/errors';
import {
    actions as riderActions,
    selectors as riderSelectors,
    types as riderTypes,
} from '../../../redux/reducers/riders';
import { actions as companyActions, selectors as companySelectors } from '../../../redux/reducers/companies';
// Ressources
import DateUtils from '../../../utils/dateUtils';
import FormattingUtils from '../../../utils/formattingUtils';
import FormUtils from '../../../utils/forms';
import ObjectUtils from '../../../utils/objectUtils';
import StringUtils from '../../../utils/stringUtils';
import UserUtils, { AccountRight, RightRank } from '../../../utils/userUtils';
import styles from './user-view-style';
import { createPath, paths } from '../../paths';
import ChartsUtils from '../../../utils/chartsUtils';
import { getBanReason } from '../../../utils/businessUtils';
import { FEATURE_MULTIGROUP } from '../../../utils/constants';
import { getListCompaniesURL } from '../../../utils/core-api';
import ViewEditBlock from '../../../components/viewEditBlock';
import FastTabs, { TabsDatas } from '../../../components/tabs/tabs';
import { clsx } from '../../../utils/htmlUtils';
import { ChangeUserGroupPayload, EditUserPayload } from '../../../redux/reducers/ws-types';
import envConfig from '../../../config';
import withGlobalStyles from '../../../utils/global-styles';

interface UserViewProps extends WithTranslation, WithStyles, RouteComponentProps {
    globalClasses: any;
    match: match<TParams>;
    riders: RiderById;
    contracts: CompanyById;
    getRiderError: ErrorPayload;
    getUserError: ErrorPayload;
    editRiderError: ErrorPayload;
    impersonateUserError: ErrorPayload;
    getRider: (id: string) => void;
    editRider: (id: string, payload: any, onDone: Function) => void;
    anonRider: (id: string, ok: boolean) => void;
    patchRider: (id: string, payload: any, onDone: Function) => void;
    resetRiderPassword: (email: string, callback: React.EffectCallback) => void;
    changeRiderCompany: (id: string, idCompany: any) => void;
    setAdminCompany: (id: string | number, idCompany: any, payload: any) => void;
    impersonateUser: (id: string, callback: React.EffectCallback) => void;
    editUser: (id: string, payload: EditUserPayload, callback: React.EffectCallback) => void;
    changeUserGroup: (
        id: string,
        payload: ChangeUserGroupPayload,
        callback: React.EffectCallback,
        errorCallback?: React.EffectCallback,
    ) => void;
    getContractGroups: (id: string, callback?: React.EffectCallback, errorCallback?: React.EffectCallback) => void;
    clearError: (errorType: string) => void;
    dispatchError: (payload: { errorType: string; message: string }) => void;
}

interface UserViewState {
    formData: any;
    initFormData: any;
    formCredit: any;
    modeChangeCompany: boolean;
    text: string;
    idc: any;
    // LT-876: per contract, so one failing fetch degrades one block
    groupOptions: { [contractUuid: string]: 'loading' | 'loaded' | 'error' };
}

// Contract: _platform/docs/features/multigroup-collaborator-attribution.md
class UserViewPage extends React.Component<UserViewProps, UserViewState> {
    canActions: boolean = UserUtils.checkRights({
        name: AccountRight.RIDER_PROFILE,
        mode: RightRank.W,
    });
    canChangeCompanySettings: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_SETTINGS,
        mode: RightRank.W,
    });
    canCreatePromo: boolean = UserUtils.checkRights({
        name: AccountRight.PROMO_DETAILS,
        mode: RightRank.W,
    });
    canImpersonate: boolean =
        UserUtils.checkRights({
            name: AccountRight.SEC_IMPERSONATE,
            mode: RightRank.R,
        }) ||
        UserUtils.checkRights({
            name: AccountRight.SEC_IMPERSONATE_EXTENDED,
            mode: RightRank.R,
        });

    alertRef: any;

    state = {
        formData: {} as any,
        initFormData: {},
        formCredit: {} as any,
        modeChangeCompany: false,
        text: '',
        idc: -1,
        groupOptions: {} as { [contractUuid: string]: 'loading' | 'loaded' | 'error' },
    };

    componentDidMount() {
        this.load();
    }

    load = (): void => {
        // A failure recorded for the entity we come from would otherwise greet the next
        // one with the retry panel instead of the loader.
        this.props.clearError(riderTypes.GET_USER);

        const id = this.props.match.params.id;

        if (!this.props.riders[id]) {
            this.props.getRider(id);
        }
        this.fetchGroupOptions();
    };

    componentDidUpdate() {
        this.fetchGroupOptions();
    }

    /**
     * LT-876 - a collaborator can hold memberships in several contracts, so the
     * group picker needs the groups of each. One request per contract, issued
     * as memberships appear and never batched: a contract whose groups cannot
     * be loaded must degrade to its own block, not blank the sheet.
     */
    fetchGroupOptions = () => {
        const riderPayload = this.props.riders[this.props.match.params.id] as unknown as RiderNew;
        for (const membership of this.membershipsOf(riderPayload)) {
            const contractUuid = membership.uuid;
            if (!contractUuid || this.state.groupOptions[contractUuid]) {
                continue;
            }
            this.setState((previous) => ({
                groupOptions: { ...previous.groupOptions, [contractUuid]: 'loading' },
            }));
            this.props.getContractGroups(
                contractUuid,
                () =>
                    this.setState((previous) => ({
                        groupOptions: { ...previous.groupOptions, [contractUuid]: 'loaded' },
                    })) as any,
                () =>
                    this.setState((previous) => ({
                        groupOptions: { ...previous.groupOptions, [contractUuid]: 'error' },
                    })) as any,
            );
        }
    };

    /**
     * Every (contract, group) membership, most recently granted first - that is
     * the one `company` carries - then by contract name. Falls back to the
     * singular field so an `id` that does not send `companies` still renders,
     * which is also what FEATURE_MULTIGROUP holds it to until `id` ships: one
     * block, the same one the sheet showed before LT-876.
     */
    membershipsOf = (riderPayload?: RiderNew): Membership[] => {
        if (!riderPayload) {
            return [];
        }
        const all =
            FEATURE_MULTIGROUP && riderPayload.companies?.length
                ? [...riderPayload.companies]
                : riderPayload.company?.uuid
                  ? [riderPayload.company]
                  : [];
        const legacy = riderPayload.company;
        return all.sort((a, b) => {
            const aIsLegacy = a.uuid === legacy?.uuid && a.group?.uuid === legacy?.group?.uuid;
            const bIsLegacy = b.uuid === legacy?.uuid && b.group?.uuid === legacy?.group?.uuid;
            if (aIsLegacy !== bIsLegacy) {
                return aIsLegacy ? -1 : 1;
            }
            return (a.name || '').localeCompare(b.name || '');
        });
    };

    /**
     * A membership's identity inside the cell identifiers. Position cannot play
     * that role: the sort above puts the membership matching the singular
     * `company` first, a move changes which one that is, and `settle` reloads
     * the rider - so an index bound at render time can denote a different
     * membership by the time the next submit resolves it.
     *
     * The trailing index keeps the identifier unique even if two memberships
     * were to carry the same (contract, group) pair; the submit resolves on the
     * first two segments only, since such a pair denotes one membership and a
     * duplicate would make the two interchangeable anyway.
     */
    membershipKey = (membership: Membership, index: number): string =>
        `${membership.uuid}__${membership.group?.uuid ?? ''}__${index}`;

    static getDerivedStateFromProps(props, state) {
        const id = props.match.params.id;
        const riderPayload = props.riders[id];
        if (riderPayload && !state.formData.id) {
            // LT-876: the group-options fetch moved to fetchGroupOptions, which
            // issues one request per contract from the lifecycle methods
            return {
                formData: ObjectUtils.deepCopy(riderPayload),
                initFormData: ObjectUtils.deepCopy(riderPayload),
                formCredit: { id, account_type: AccountType.PERSO, amount: '', text: '' },
            };
        }
        return null;
    }

    //====================================//
    //=============== This ===============//
    //====================================//
    bookingsOptions: Highcharts.Options = null;

    //=============================================//
    //=============== Event Handler ===============//
    //=============================================//

    handleChange = (event) => {
        this.setState(FormUtils.nextSubState(event, this.state, 'formCredit'));
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const { formData } = this.state;
        const id = this.props.match.params.id;

        const payload = {
            obp: formData.obp,
            vip: formData.vip,
            banned: formData.banned,
            ban_description: !formData.banned ? '' : formData.ban_description,
        };

        this.props.editRider(id, payload, () => {
            delete this.state.formData.obp;
            delete this.state.formData.vip;
            this.setState({
                initFormData: this.state.formData,
            });
        });
    };

    handleChangeCompanySubmit = (event) => {
        event.preventDefault();
        const { idc } = this.state;
        const id = this.props.match.params.id;
        if (idc > 0) {
            this.props.changeRiderCompany(id, idc);
        }
    };

    handleSubmitCredit = (event) => {
        event.preventDefault();
        const id = this.props.match.params.id;
        this.props.patchRider(id, this.state.formCredit, () => {
            this.setState({
                formCredit: { id, account_type: AccountType.PERSO, amount: '', text: '' },
            });
        });
    };

    handleAnon = (ok: boolean) => () => {
        const id = this.props.match.params.id;
        this.props.anonRider(id, ok);
    };

    openCompanyChange = () => {
        this.setState((prevState) => ({
            modeChangeCompany: !prevState.modeChangeCompany,
        }));
    };

    handleChangeFormData = (event) => {
        this.setState(FormUtils.nextSubState(event, this.state, 'formData'));
    };

    handleSetCompanyAdmin = (riderPayload: Rider) => (e) => {
        this.props.setAdminCompany(riderPayload.id, riderPayload.active_company_membership.company?.id, {
            admin: !riderPayload.active_company_membership.admin,
        });
    };

    handleImpersonateUser = (riderPayload: Rider) => (e) => {
        this.props.impersonateUser(`${riderPayload.id}`, () => {
            UserUtils.setImpersonateInfos(window.location.href);
            window.location.href = `${envConfig.webapp_rider_url}`;
        });
    };

    handleSubmitInfos = (editedDatas: any, fullDatas: any, onSuccess: () => void, onError: () => void) => {
        if (editedDatas) {
            console.log('Processing data:', editedDatas, 'fulldatas', fullDatas);

            const { getRider, editUser, match } = this.props;
            const id = match.params.id;
            const riderPayload = this.props.riders[id];

            const payload: EditUserPayload = {
                firstname: fullDatas.firstname,
                lastname: fullDatas.lastname,
                emails: [
                    {
                        old_email: riderPayload.email,
                        new_email: fullDatas.email,
                    },
                ],
                language: fullDatas.language,
                phone: {
                    number: fullDatas.phone,
                    country: 'fr', // TODO: mettre une lib pour numéro
                },
            };
            // console.log(payload);
            editUser(id, payload, () => {
                getRider(id);
                onSuccess();
            });
        } else {
            onError();
        }
    };

    handleSubmitParameters = (editedDatas: any, fullDatas: any, onSuccess: () => void, onError: () => void) => {
        if (editedDatas && editedDatas.vip !== undefined) {
            const { getRider, editUser, match } = this.props;
            const id = match.params.id;

            const payload: EditUserPayload = {
                vip: !!editedDatas.vip,
            };
            editUser(id, payload, () => {
                getRider(id);
                onSuccess();
            });
        } else {
            onError();
        }
    };

    handleSubmitCompanyInfos = (editedDatas: any, fullDatas: any, onSuccess: () => void, onError: () => void) => {
        if (editedDatas) {
            console.log('Processing data:', editedDatas, 'fulldatas', fullDatas);

            const { getRider, changeUserGroup, clearError, dispatchError, match, t } = this.props;
            const id = match.params.id;
            const riderPayload = this.props.riders[id] as unknown as RiderNew;
            const memberships = this.membershipsOf(riderPayload);

            /**
             * LT-876 - the contract AND the source group come from the row that
             * was edited. Sending only the contract made `id` revoke every
             * membership the collaborator held in it.
             *
             * Both come out of the cell identifier rather than out of a
             * position, so a key left over from an earlier submit resolves to
             * the membership it was written for or to none at all - never to
             * whichever membership now sits at that index.
             */
            const moves = Object.keys(editedDatas)
                .filter((key) => key.startsWith('group__'))
                .map((key) => {
                    const [contractUuid, fromGroupUuid = ''] = key.slice('group__'.length).split('__');
                    return {
                        membership: memberships.find(
                            (m) => m.uuid === contractUuid && (m.group?.uuid ?? '') === fromGroupUuid,
                        ),
                        group_uuid: editedDatas[key],
                    };
                })
                .filter(
                    (move): move is { membership: Membership; group_uuid: string } =>
                        !!move.membership && !!move.group_uuid,
                );

            /**
             * `findError` returns the FIRST entry matching the type and nothing
             * in this page clears the store, so an earlier failure would keep
             * being the one `editRiderError` hands to <ErrorMessage> - the new
             * one would change neither the payload nor its identity, and the
             * operator would be told nothing. And the entry that shadows it
             * need not be a group move: this page has five other handlers
             * writing to the same banner, so a credit patch refused a minute
             * ago outranks whatever this submit dispatches.
             *
             * So clear every type the banner reads - the list is exported
             * beside the selector, since a copy of it here would drift. That
             * does drop a sibling failure the operator has not acknowledged,
             * which is a real loss and the reason it is spelled out: only one
             * of these seven is ever on screen, so the choice is between
             * losing a message that was already displayed and read, and
             * letting it hide a refused move the operator would never hear
             * about. A silent data failure is the worse of the two.
             *
             * `getRiderError` is a separate banner and is deliberately left
             * alone - nothing here supersedes a failed reload.
             */
            editRiderErrorTypes.forEach((type) => clearError(type));

            if (moves.length === 0) {
                // Every edited row resolved to nothing, so the keys are stale:
                // the rider was reloaded between the render that wrote them and
                // this submit. Nothing is sent, and saying so is the point -
                // silently reverting the operator's pick is indistinguishable
                // from a save that worked.
                dispatchError({
                    errorType: riderTypes.CHANGE_USER_GROUP,
                    message: t('group_move_stale'),
                });
                onError();
                return;
            }

            /**
             * One call per edited row, so the sheet has to wait for all of
             * them and not only for the ones that worked. A refused move puts
             * its memberships back, but the moves that already went through
             * are real - the rider is reloaded either way.
             *
             * On failure the sheet stays in edit mode and ViewEditBlock drops
             * the edited values, so every row falls back to what was reloaded:
             * the refused one shows the group still in force, which is how the
             * operator tells it apart from the ones that moved. The failure
             * itself surfaces through `editRiderError`, which now watches
             * CHANGE_USER_GROUP.
             */
            const pending = { count: moves.length, failed: 0 };
            const settle = () => {
                pending.count -= 1;
                if (pending.count > 0) return;
                getRider(id);
                if (pending.failed === 0) {
                    onSuccess();
                } else {
                    onError();
                }
            };

            moves.forEach(({ membership, group_uuid }) => {
                const payload: ChangeUserGroupPayload = {
                    contract_uuid: membership.uuid,
                    group_uuid,
                    // an `id` without LT-876 does not read the source group, and
                    // resolves the move on the contract alone - so until the
                    // flag is on, send it the request it already answers rather
                    // than one it would silently read as something else
                    ...(FEATURE_MULTIGROUP ? { from_group_uuid: membership.group?.uuid } : {}),
                };
                changeUserGroup(id, payload, settle, () => {
                    pending.failed += 1;
                    settle();
                });
            });
        } else {
            onError();
        }
    };

    //=============================================//
    //=============== Graph Methods ===============//
    //=============================================//

    getPickupDate(date: Date): number {
        date.setHours(0, 0, 0, 0);
        return date.getTime();
    }

    getResults(bookings_recent): any {
        const { cancelled, ride_ended, others } = bookings_recent.reduce(
            (all, { creation_date, status: s }) => {
                const status = s === 'cancelled' || s === 'ride_ended' ? s : 'others';
                const ts = this.getPickupDate(new Date(creation_date.date));
                const found = all[status].find((item) => item.ts === ts);
                if (!found) {
                    all[status].push({ ts, val: 1 });
                } else {
                    found.val++;
                }
                return all;
            },
            { cancelled: [], ride_ended: [], others: [] },
        );
        return {
            cancelled: cancelled.map(Object.values),
            ended: ride_ended.map(Object.values),
            others: others.map(Object.values),
        };
    }

    createGraph = (payload): void => {
        const { t } = this.props;

        if (!payload || !payload.bookings_recent || payload.bookings_recent.length <= 0) {
            return;
        }

        const { cancelled, ended, others } = this.getResults(payload.bookings_recent);

        // Load bookings Graph
        const bookings_per_app: Highcharts.SeriesOptionsType[] = [
            {
                name: t('booking:booking_status_cancelled'),
                type: 'line',
                data: cancelled,
            },
            {
                name: t('booking:booking_status_ride_ended'),
                type: 'line',
                data: ended,
            },
            { name: t('graph.others'), type: 'line', data: others },
            // { 'name': t('graph.drive'), 'type': 'line', 'data': courses }
        ];

        this.bookingsOptions = ChartsUtils.createBookingsChart(t, bookings_per_app);
    };

    generateGroupOptions(contractUuid?: string): FormPickerDatas[] {
        if (!contractUuid) {
            return [];
        }

        const contract = this.props.contracts[contractUuid] as any;
        const groupOptions: FormPickerDatas[] = contract?.groups?.map(({ id, name }) => ({
            id,
            name,
        }));
        return groupOptions || [];
    }

    generateEditableListItem = (riderPayload: RiderNew): ViewEditCell[] => {
        const { t } = this.props;
        if (!riderPayload) {
            return [];
        }

        const listItem: ViewEditCell[] = [
            { id: 'firstname', title: t('common:form.firstname'), data: riderPayload.firstname },
            { id: 'lastname', title: t('common:form.lastname'), data: riderPayload.lastname },
            { id: 'email', title: t('common:form.email'), data: riderPayload.email, type: FormatType.Email },
            { id: 'phone', title: t('common:form.phone_number'), data: riderPayload.phone, type: FormatType.Phone },
            {
                id: 'language',
                title: t('common:form.lang'),
                data: riderPayload.language,
                cellType: 'Picker',
                options: FormUtils.generateLangOptions(t),
            },
            // {
            //     title: t('default_booking_address'),
            //     readOnly: true,
            //     data: riderPayload.default_booking_address,
            //     type: FormatType.Address,
            //     optional: true,
            // },
            // {
            //     title: t('total_net_30'),
            //     readOnly: true,
            //     data: riderPayload.total_net_price_without_vat_generated_recently,
            //     type: FormatType.Price,
            // },
            // {
            //     title: t('total_net'),
            //     readOnly: true,
            //     data: riderPayload.total_net_price_without_vat,
            //     type: FormatType.Price,
            // },
            // {
            //     title: t('recent_invoice'),
            //     readOnly: true,
            //     data: (
            //         <Link
            //             color="secondary"
            //             component={RouterLink}
            //             to={`${paths.billsSimple}?filters[user_id]=${riderPayload.uuid}`}
            //         >
            //             {t('common:click_to_see')}
            //         </Link>
            //     ),
            // },
            // {
            //     title: t('promotions.title'),
            //     readOnly: true,
            //     data: this.renderPromotionsViews(riderPayload),
            //     optional: true,
            // },
            // {
            //     title: t('common:form.additional_infos'),
            //     data: riderPayload.additional_info,
            //     optional: true,
            // },
        ];

        return listItem;
    };

    generateCompanyFixedListItem = (riderPayload: RiderNew): ViewEditCell[] => {
        const { t } = this.props;
        if (!riderPayload) {
            return [];
        }

        /**
         * LT-876 - one block per membership instead of four singular cells.
         * Cell identifiers carry the membership's own key, because the edit
         * container keys the values it hands back by identifier and that is
         * how handleSubmitCompanyInfos knows which membership was edited.
         */
        const memberships = this.membershipsOf(riderPayload);
        const orphanInvites = this.orphanInvitesOf(riderPayload, memberships);
        const listItem: ViewEditCell[] = [];

        if (memberships.length === 0) {
            listItem.push({
                id: 'company',
                title: t('company'),
                readOnly: true,
                data: t('no_membership'),
                optional: true,
            });
        }

        memberships.forEach((membership, index) => {
            const status = this.state.groupOptions[membership.uuid];
            const key = this.membershipKey(membership, index);
            /**
             * The contract heads its own band rather than taking a cell among
             * the others: four cells in a three-column grid wrapped, so the
             * cells of one membership ran on into the next with nothing to
             * tell the two apart. The three cells left fill exactly one row
             * under the band.
             */
            listItem.push({
                id: `company__${key}`,
                title: t('company'),
                sectionCell: true,
                readOnly: true,
                data: (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={`${paths.contracts}/${membership.uuid}`}
                    >{`${membership.name}`}</Link>
                ),
                optional: true,
            });
            listItem.push({
                id: `group__${key}`,
                title: t('group'),
                // a contract whose groups did not load stays readable, and is
                // not editable with an empty picker
                readOnly: status !== 'loaded',
                data: membership.group?.uuid,
                hint: status === 'error' ? t('group_options_error') : undefined,
                optional: true,
                cellType: 'Picker',
                options: this.generateGroupOptions(membership.uuid),
            });
            listItem.push({
                id: `group_roles__${key}`,
                title: t('group_roles'),
                readOnly: true,
                data: membership.group?.role?.join(', '),
                optional: true,
            });
            listItem.push({
                id: `group_status__${key}`,
                title: t('group_status'),
                readOnly: true,
                data: this.renderInvitesViews(riderPayload, membership),
                optional: true,
            });
        });

        if (orphanInvites.length > 0) {
            listItem.push({
                id: 'group_status__invites',
                title: t('pending_invitations'),
                sectionCell: true,
                readOnly: true,
                data: this.renderInviteLines(orphanInvites),
                optional: true,
            });
        }

        return listItem;
    };

    generateFixedListItem = (riderPayload: RiderNew): ViewEditCell[] => {
        const { t } = this.props;
        if (!riderPayload) {
            return [];
        }

        const listItem: ViewEditCell[] = [
            { id: 'id', title: t('common:form.id'), data: riderPayload.core_id, readOnly: true },
            {
                id: 'grants',
                title: t('grants'),
                readOnly: true,
                data: this.renderGrantsViews(riderPayload),
                optional: true,
            },
            {
                id: 'subscription_date',
                title: t('subscription_date'),
                readOnly: true,
                data: riderPayload.subscription_date,
                type: FormatType.DateLong,
            },
            {
                id: 'fraud_score',
                title: t('fraud_score'),
                readOnly: true,
                data: riderPayload.fraud_score ?? '0',
                customStyle: FormattingUtils.fraudscoreToStyle(riderPayload.fraud_score),
                optional: true,
            },
        ];

        if (riderPayload.booking_suspended) {
            listItem.push({
                id: 'booking_suspended',
                title: t('common:suspended'),
                readOnly: true,
                data: t('booking_suspended_desc'),
                customStyle: { color: 'red' },
            });
        }

        return listItem;
    };

    generateParametersListItem = (riderPayload: RiderNew): ViewEditCell[] => {
        const { t } = this.props;
        if (!riderPayload) {
            return [];
        }

        const listItem: ViewEditCell[] = [
            {
                id: 'vip',
                title: t('parameters.vip'),
                data: riderPayload.vip,
                cellType: 'Boolean',
            },
        ];

        return listItem;
    };

    generateRideFixedListItem = (riderPayload: RiderNew): ViewEditCell[] => {
        const { t } = this.props;
        if (!riderPayload) {
            return [];
        }

        const listItem: ViewEditCell[] = [
            {
                id: 'nb_reservations',
                title: t('nb_reservations'),
                readOnly: true,
                data: !!riderPayload.nb_reservations ? (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={`${paths.reservations}?filters[rider.id]=${riderPayload.core_id}`}
                    >{`${riderPayload.nb_reservations} (${t('common:click_to_see')})`}</Link>
                ) : null,
                optional: true,
            },
            {
                id: 'nb_bookings',
                title: t('nb_bookings'),
                readOnly: true,
                data: !!riderPayload.nb_bookings ? (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={`${paths.bookings}?filters[rider.id]=${riderPayload.core_id}`}
                    >{`${riderPayload.nb_bookings} (${t('common:click_to_see')})`}</Link>
                ) : null,
                optional: true,
            },
        ];

        return listItem;
    };

    /**
     * LT-1471 - the sheet is a two-tab page: everything that describes the
     * collaborator on the first, the switches an operator flips on the second.
     * `loadAll` keeps both mounted, so switching tabs costs no refetch.
     */
    generateTabs = (riderPayload: Rider, riderPayloadNew: RiderNew): TabsDatas => {
        const { t, classes } = this.props;

        return {
            loadAll: true,
            datas: [
                {
                    label: t('tabs.general'),
                    children: (
                        <>
                            {this.bookingsOptions && (
                                <>
                                    <Anchor id="bookings_graph" />
                                    <HighchartsReact highcharts={Highcharts} options={this.bookingsOptions} />
                                    <br />
                                </>
                            )}
                            <Anchor id="general_infos" />
                            {riderPayload.photo_url && (
                                <Avatar alt="Avatar" src={riderPayload.photo_url} className={classes.bigAvatar} />
                            )}
                            <ViewEditBlock
                                title={t('common:form.general_infos')}
                                nbColumn={3}
                                noActions={!this.canActions}
                                datas={this.generateEditableListItem(riderPayloadNew)}
                                onSubmit={this.handleSubmitInfos}
                            />
                            <Anchor id="company_infos" />
                            <ViewEditBlock
                                title={t('common:form.company')}
                                nbColumn={3}
                                noLock={!riderPayloadNew?.company?.uuid}
                                noActions={!riderPayloadNew?.company?.uuid}
                                datas={this.generateCompanyFixedListItem(riderPayloadNew)}
                                onSubmit={this.handleSubmitCompanyInfos}
                            />
                            <Anchor id="additional_infos" />
                            <ViewEditBlock
                                title={t('common:form.additional_infos')}
                                nbColumn={3}
                                noLock
                                noActions
                                datas={this.generateFixedListItem(riderPayloadNew)}
                            />
                            <Anchor id="ride_infos" />
                            <ViewEditBlock
                                title={t('ride_infos')}
                                nbColumn={3}
                                noLock
                                noActions
                                datas={this.generateRideFixedListItem(riderPayloadNew)}
                            />
                            {/* 
                                Actions to ADD or NOT ??
                                     (this.canChangeCompanySettings || this.canActions) && (
                                         <>
                                             {this.canActions && (
                                                 <>
                                                     {!riderPayload.anonymized && (
                                                         <Dialog
                                                             btnTitle={t('remove_infos')}
                                                             description={t('remove_infos_desc')}
                                                             onOK={this.handleAnon(true)}
                                                         />
                                                     )}
                                                     {riderPayload.anonymized === 2 && (
                                                         <Dialog
                                                             btnTitle={t('remove_infos_cancel')}
                                                             description={t('remove_infos_cancel_desc')}
                                                             onOK={this.handleAnon(false)}
                                                         />
                                                     )}
                                                 </>
                                             )}
                                             {this.canChangeCompanySettings && (
                                                 <>
                                                     // {riderPayload?.company_memberships?.length > 0 && <Button size="small" color="secondary" variant='contained' onClick={this.openCompanyChange}>{t('change_company')}</Button>}
                                                     <Button
                                                         color="secondary"
                                                         variant="contained"
                                                         onClick={this.openCompanyChange}
                                                     >
                                                         {t('change_company')}
                                                     </Button>
                                                     {riderPayload.active_company_membership && (
                                                         <Button
                                                             color="secondary"
                                                             variant="contained"
                                                             onClick={this.handleSetCompanyAdmin(riderPayload)}
                                                         >
                                                             {t(
                                                                 riderPayload.active_company_membership.admin
                                                                     ? 'admin.remove'
                                                                     : 'admin.set',
                                                             )}
                                                         </Button>
                                                     )}
                                                 </>
                                             )}
                                         </>
                                     )
                            */}
                            <br />
                            {this.renderChangeCompany(riderPayload)}
                            {/* {this.canChangeCompanySettings && formData.id && (
                                <FormSubmit debounceSubmit={{ callback: this.handleSubmit }}>
                                    <Anchor id="additional_infos" />
                                    <Typobold>{t('common:form.additional_infos')}</Typobold>
                                    <Card className={clsx(classes.card, classes.partnerInfo)}>
                                        <CardContent>
                                            <List>
                                                {this.renderListItems(riderPayload)}
                                                {formData.company_memberships?.length > 0 && <hr />}
                                                {this.renderCompanyMemberships(riderPayload)}
                                            </List>
                                        </CardContent>
                                        <CardActions>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color={
                                                    ObjectUtils.isEqual(formData, initFormData) ? 'inherit' : 'secondary'
                                                }
                                            >
                                                {t('common:validate')}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </FormSubmit>
                            )} */}
                            {/* <br />
                            {this.renderFormCredit(riderPayload)}
                            <br />
                            <AnchorBlock
                                id="credits_logs"
                                title={t('credits_logs')}
                                items={
                                    riderPayload?.credit_logs ? (
                                        <Table className={classes.table} size="small" aria-label="Table credit logs">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>{t('date')}</TableCell>
                                                    <TableCell>{t('type')}</TableCell>
                                                    <TableCell>{t('amount')}</TableCell>
                                                    <TableCell align="center">{t('reason')}</TableCell>
                                                    <TableCell align="right">{t('respo')}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>{this.renderCreditLogsRows(riderPayload)}</TableBody>
                                        </Table>
                                    ) : null
                                }
                            /> */}
                            <ActionLogs history={riderPayload.history} withValues />
                        </>
                    ),
                },
                {
                    label: t('tabs.parameters'),
                    children: (
                        <ViewEditBlock
                            title={t('parameters.title')}
                            nbColumn={3}
                            noActions={!this.canActions}
                            datas={this.generateParametersListItem(riderPayloadNew)}
                            onSubmit={this.handleSubmitParameters}
                        />
                    ),
                },
            ],
        };
    };

    getActions = (riderPayload: Rider): any[] => {
        const { t } = this.props;
        const actions: ActionFunction[] = [];
        if (this.canCreatePromo) {
            actions.push({
                label: t('promotions.create'),
                func: () =>
                    this.props.history.push(
                        createPath(paths.ridersPromotion, { id: (this.props.match.params as any).id }),
                    ),
            });
        }
        // if (this.canImpersonate) {
        //     actions.push({
        //         label: t('common:impersonate.action'),
        //         func: this.handleImpersonateUser(riderPayload),
        // }
        return actions;
    };

    generateAppHeader = (riderPayload: Rider): any => {
        const { t } = this.props;
        return {
            icon: 'default',
            title: StringUtils.userFullname(riderPayload),
            subtitle: riderPayload && `ID: ${riderPayload.id}`,
            bubble: {
                visible: riderPayload?.banned || riderPayload?.booking_suspended,
                text: t('common:suspended'),
                tooltip: riderPayload?.booking_suspended ? t('booking_suspended') : t('driver:ban_reason.manual'),
            },
            actions: this.getActions(riderPayload),
            additionalActions: this.canImpersonate && [
                {
                    label: t('common:impersonate.action'),
                    func: this.handleImpersonateUser(riderPayload),
                },
            ],
            anchors: [
                { href: '#bookings_graph', label: t('graph.bookings') },
                { href: '#general_infos', label: t('common:form.general_infos') },
                { href: '#additional_infos', label: t('common:form.additional_infos') },
                // { href: '#credit', label: t('credit.title') },
                // { href: '#credits_logs', label: t('credits_logs') },
            ],
        };
    };

    //======================================//
    //=============== Render ===============//
    //======================================//

    renderGrantsViews = (riderPayload: RiderNew): JSX.Element[] => {
        const { active_connections } = riderPayload;
        if (active_connections?.length > 0) {
            return active_connections.map((item, index) => (
                <ListItemText key={index}>
                    {DateUtils.tsToDate(item.created_at)}
                    {`\t-\t${item.source}`}
                </ListItemText>
            ));
        }
        return null;
    };

    renderPromotionsViews = (riderPayload: Rider): JSX.Element[] => {
        const { t } = this.props;
        const { promotions } = riderPayload;
        if (promotions?.length > 0) {
            return promotions.map(({ promotion, is_active }, index) => (
                <TooltipButton key={index} title={promotion?.description || ''}>
                    <ListItemText>
                        <div style={is_active ? { fontWeight: 'bold' } : {}}>
                            {promotion?.code || promotion?.name}
                            {`\t- ${t('promotions.use_limit')}:\t${promotion?.use_limit} -\t${t(
                                is_active ? 'promotions.is_active' : 'promotions.is_not_active',
                            )}`}
                        </div>
                    </ListItemText>
                </TooltipButton>
            ));
        }
        return null;
    };

    /**
     * The pending invitations that belong to no membership block. An invitation
     * is by definition to a contract the collaborator does not hold yet, so
     * this is the normal case rather than an edge, and the blocks above would
     * drop them.
     *
     * It is also the graceful path for an `id` that predates LT-876 and still
     * puts the invitee's own uuid in `invity` instead of the contract's: none
     * of them matches a membership, so every one lands here - which is the
     * ungrouped list the sheet showed before there was a block per membership.
     */
    orphanInvitesOf = (riderPayload: RiderNew, memberships: Membership[]): Membership[] =>
        riderPayload?.invity?.filter((invite) => !memberships.some((m) => m.uuid === invite.uuid)) ?? [];

    renderInviteLines = (invitations: Membership[], scoped = false): JSX.Element[] => {
        const { t } = this.props;
        return invitations.map(({ name, group }) => (
            <div key={`invited${name}${group?.uuid}`}>
                {scoped ? `${t('group_invited')}: ${group?.name}` : `${t('group_invited')}: ${name} - ${group?.name}`}
            </div>
        ));
    };

    /**
     * LT-876 - scoped to one membership when given one, so a collaborator in
     * several groups does not repeat the same status under each of them.
     * Pending invitations are shown against the contract they belong to; the
     * ones matching no membership are rendered once, by the caller.
     */
    renderInvitesViews = (riderPayload: RiderNew, membership?: Membership): JSX.Element[] | JSX.Element => {
        const { t } = this.props;
        const { company, invity } = riderPayload;
        const shown = membership ?? company;
        const res = [];
        if (shown) {
            // under a membership band the contract already heads the block and
            // the group sits in the picker beside this cell, so the status is
            // the status alone
            res.push(
                <div key="validated">
                    {membership
                        ? t('group_validated')
                        : `${t('group_validated')}: ${shown?.name} - ${shown?.group?.name}`}
                </div>,
            );
        }
        const invitations = membership ? invity?.filter((i) => i.uuid === membership.uuid) : invity;
        if (invitations?.length > 0) {
            res.push(...this.renderInviteLines(invitations, !!membership));
        }
        return res;
    };

    renderCompanyMembershipsViews = (riderPayload: Rider): JSX.Element[] => {
        const { t } = this.props;
        const { company_memberships } = riderPayload;
        if (company_memberships?.length > 0) {
            return company_memberships
                .filter((c) => c.status !== 'ended')
                .map((cmp, index) => (
                    <ListItemText key={index}>
                        <Link color="secondary" component={RouterLink} to={`${paths.companies}/${cmp.company.id}`}>
                            {cmp.company.name}
                        </Link>
                        {`\t (${t('company_status.' + cmp.status)})`}
                        {cmp.department?.id && (
                            <>
                                {` - ${t('department')} : `}
                                <Link
                                    color="secondary"
                                    component={RouterLink}
                                    to={`${paths.companies}/${cmp.department.id}`}
                                >
                                    {cmp.department.name}
                                </Link>
                            </>
                        )}
                    </ListItemText>
                ));
        }
        return null;
    };

    renderCreditLogsRows = (riderPayload: Rider): JSX.Element[] => {
        return riderPayload.credit_logs.map(({ admin, date, account_type, id, amount, text }) => {
            const respo = StringUtils.userFullname(admin);
            return (
                <TableRow key={id}>
                    <TableCell component="th" scope="row">
                        {DateUtils.tsToDate(date, true)}
                    </TableCell>
                    <TableCell>{account_type}</TableCell>
                    <TableCell>{FormattingUtils.price(amount)}</TableCell>
                    <TableCell align="center">{text}</TableCell>
                    <TableCell align="right">{respo}</TableCell>
                </TableRow>
            );
        });
    };

    renderFormCredit = (riderPayload: Rider): JSX.Element => {
        const { formCredit } = this.state;
        const { t, classes } = this.props;
        return (
            formCredit?.id && (
                <FormSubmit debounceSubmit={{ callback: this.handleSubmitCredit }}>
                    <Anchor id="credit" />
                    <Typobold>{t('credit.title')}</Typobold>
                    <Card className={clsx(classes.card, classes.partnerInfo)}>
                        <CardContent>
                            <Typography variant="subtitle1" component="p">
                                {t('credit.hint')}
                            </Typography>
                            <Typography variant="subtitle2" component="p">{`${t('credit.available')} - ${'\t'}${t(
                                'credit.type.perso',
                            )}: ${FormattingUtils.price(riderPayload.credit_perso, true)}  /  ${t(
                                'credit.type.pro',
                            )}: ${FormattingUtils.price(riderPayload.credit_pro, true)}`}</Typography>
                            <div className={classes.formInputs}>
                                <FormControl margin="dense">
                                    <InputLabel htmlFor="account_type">{t('credit.type.title')}</InputLabel>
                                    <Select
                                        native
                                        id="account_type"
                                        name="account_type"
                                        value={formCredit.account_type}
                                        className={classes.formInput}
                                        required={true}
                                        onChange={this.handleChange}
                                    >
                                        <option value={AccountType.PERSO}>{t('credit.type.perso')}</option>
                                        <option value={AccountType.PRO}>{t('credit.type.pro')}</option>
                                    </Select>
                                </FormControl>
                                <FormControl margin="dense">
                                    <InputLabel htmlFor="amount">{t('credit.amount')}</InputLabel>
                                    <Input
                                        id="amount"
                                        name="amount"
                                        value={formCredit.amount}
                                        type="number"
                                        className={classes.formInput}
                                        required={true}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                                <FormControl margin="dense">
                                    <InputLabel htmlFor="text">{t('credit.motive')}</InputLabel>
                                    <Input
                                        id="text"
                                        name="text"
                                        value={formCredit.text}
                                        className={classes.formInput}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                            </div>
                        </CardContent>
                        <CardActions className={classes.rightActions}>
                            <Button type="submit" variant="contained">
                                {t('common:validate')}
                            </Button>
                        </CardActions>
                    </Card>
                </FormSubmit>
            )
        );
    };

    renderChangeCompany = (riderPayload: Rider): JSX.Element => {
        const { modeChangeCompany, text } = this.state;
        const { t, classes } = this.props;
        return (
            modeChangeCompany && (
                <FormSubmit debounceSubmit={{ callback: this.handleChangeCompanySubmit }}>
                    <Typobold>{t('change_company')}</Typobold>
                    <Card className={clsx(classes.card, classes.partnerInfo)}>
                        <CardContent>
                            <List>
                                <ListItem style={{ textAlign: 'center', flex: 1 }}>
                                    <AutoFill
                                        datas={{
                                            id: 'newCompany',
                                            label: t('new_company'),
                                            minChar: 1,
                                            style: { width: '100%' },
                                            formData: this.state,
                                            variant: 'outlined',
                                            onChange: (idc, newText) => {
                                                this.setState({ idc, text: newText });
                                            },
                                            loaderPosition: 'right',
                                            api: getListCompaniesURL(),
                                        }}
                                    />
                                </ListItem>
                            </List>
                        </CardContent>
                        <CardActions>
                            <Button
                                type="submit"
                                variant="contained"
                                color={
                                    text.length === 0 ||
                                    riderPayload.company_memberships.findIndex((c) => c.company.name === text) !== -1
                                        ? 'inherit'
                                        : 'secondary'
                                }
                            >
                                {t('common:validate')}
                            </Button>
                        </CardActions>
                    </Card>
                    <br />
                </FormSubmit>
            )
        );
    };

    renderCompanyMemberships = (riderPayload: Rider): JSX.Element => {
        const { formData } = this.state;
        const { t, classes } = this.props;
        if (!formData?.company_memberships || formData.company_memberships.length === 0) {
            return null;
        }

        return (
            <>
                <div>{t('company_type.obp_hint')}</div>
                {formData.company_memberships.map((cmp: CompanyMembership, index) => {
                    return (
                        <ListItem key={index}>
                            <div style={{ marginRight: 8 }} className={classes.partnerInfoLabel}>
                                {cmp.company.name}
                            </div>
                            {cmp.status === 'ended' && (
                                <div style={{ marginRight: 20 }} className={classes.partnerWarningLabel}>
                                    {t('company_status.ended')}
                                </div>
                            )}
                            <TooltipButton title={t('company_type.obp_desc')}>
                                <FormLabel>{t('company_type.obp')}</FormLabel>
                            </TooltipButton>
                            <FormControl margin="dense">
                                <Checkbox
                                    style={{ marginLeft: 8 }}
                                    edge="start"
                                    checked={cmp.onboard_payment}
                                    disabled={
                                        cmp.department
                                            ? !cmp.department.centralized_payment
                                            : !cmp.company?.centralized_payment
                                    }
                                    onChange={() => {
                                        cmp.onboard_payment = !cmp.onboard_payment;
                                        const nextFormData = { ...formData };
                                        if (
                                            riderPayload.company_memberships[index].onboard_payment ===
                                            cmp.onboard_payment
                                        ) {
                                            delete nextFormData.obp;
                                        } else {
                                            nextFormData.obp = cmp.company.id;
                                        }
                                        this.setState({
                                            formData: nextFormData,
                                        });
                                    }}
                                    tabIndex={-1}
                                />
                            </FormControl>

                            <TooltipButton title={t('company_type.vip_desc')}>
                                <FormLabel>{t('company_type.vip')}</FormLabel>
                            </TooltipButton>
                            <FormControl margin="dense">
                                <Checkbox
                                    style={{ marginLeft: 8 }}
                                    edge="start"
                                    checked={cmp.vip}
                                    onChange={() => {
                                        cmp.vip = !cmp.vip;
                                        const nextFormData = { ...formData };
                                        if (riderPayload.company_memberships[0].vip === cmp.vip) {
                                            delete nextFormData.vip;
                                        } else {
                                            nextFormData.vip = cmp.company.id;
                                        }
                                        this.setState({
                                            formData: nextFormData,
                                        });
                                    }}
                                    tabIndex={-1}
                                />
                            </FormControl>
                        </ListItem>
                    );
                })}
            </>
        );
    };

    renderListItems = (riderPayload: Rider): JSX.Element => {
        const { formData } = this.state;
        const { t, classes } = this.props;
        return (
            <ListItem>
                <FormLabel className={classes.partnerInfoLabel}>{t('common:suspended')}</FormLabel>
                <FormControl margin="dense">
                    <Checkbox
                        style={{ marginLeft: 8 }}
                        edge="start"
                        checked={formData.banned}
                        name={'banned'}
                        onChange={this.handleChangeFormData}
                        tabIndex={-1}
                    />
                </FormControl>
                {riderPayload.banned && (
                    <div>{`${t('driver:ban_reason.title')} : ${getBanReason(t, riderPayload)}`}</div>
                )}

                {formData.banned && (
                    <>
                        <FormLabel style={{ marginLeft: 16 }} className={classes.partnerInfoLabel}>
                            {t('driver:ban_description.title')}
                        </FormLabel>
                        <FormControl margin="dense">
                            <FormGroup row={true}>
                                <Input
                                    style={{ marginLeft: 8 }}
                                    id={'ban_description'}
                                    type={'text'}
                                    placeholder={t('driver:ban_description.placeholder')}
                                    name={'ban_description'}
                                    value={formData.ban_description || ''}
                                    className={classes.formInput}
                                    onChange={this.handleChangeFormData}
                                />
                            </FormGroup>
                        </FormControl>
                    </>
                )}
            </ListItem>
        );
    };

    render() {
        const { formData, initFormData } = this.state;
        const { t, match, riders, classes, globalClasses, getRiderError, editRiderError } = this.props;
        const id = match.params.id;
        const riderPayload = riders[id];
        const riderPayloadNew = riderPayload as unknown as RiderNew;

        // this.createGraph(riderPayload);

        return (
            <App
                needRights={{ name: AccountRight.RIDER_PROFILE, mode: RightRank.R }}
                loading={!riderPayload}
                loadingError={this.props.getUserError}
                onRetry={this.load}
                header={this.generateAppHeader(riderPayload)}
            >
                <ErrorMessage payload={getRiderError} />
                <ErrorMessage payload={editRiderError} />
                <ErrorMessage payload={this.props.impersonateUserError} />
                {/* <LCAlert
                    onRef={(ref) => (this.alertRef = ref)}
                    details={t('login:forgot_password_sent')}
                    type="success"
                /> */}
                {riderPayload && (
                    <div
                        className={clsx(globalClasses.blockShadowNew, classes.tabs)}
                        style={{ flex: 1, overflow: 'hidden' }}
                    >
                        <FastTabs tabs={this.generateTabs(riderPayload, riderPayloadNew)} />
                    </div>
                )}
            </App>
        );
    }
}

const UserViewPageWithStyleAndTranslation = withGlobalStyles(
    withStyles(styles)(withTranslation(['rider', 'driver', 'booking', 'common'])(UserViewPage)),
);

const mapStateToProps = (state) => ({
    riders: riderSelectors.users(state),
    getRiderError: errorSelectors.getRiderError(state),
    getUserError: errorSelectors.getUserError(state),
    editRiderError: errorSelectors.editRiderError(state),
    impersonateUserError: errorSelectors.impersonateUserError(state),
    contracts: companySelectors.getCompaniesNew(state),
});

const mapDispatchToProps = {
    clearError: errorActions.clearError,
    getRider: riderActions.getUser,
    editRider: riderActions.editRider,
    anonRider: riderActions.anonRider,
    patchRider: riderActions.patchRider,
    resetRiderPassword: riderActions.resetRiderPassword,
    changeRiderCompany: riderActions.changeRiderCompany,
    setAdminCompany: riderActions.setAdminCompany,
    impersonateUser: riderActions.impersonateUser,
    editUser: riderActions.editUser,
    changeUserGroup: riderActions.changeUserGroup,
    getContractGroups: companyActions.getContractGroups,
    dispatchError: errorActions.dispatchError,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserViewPageWithStyleAndTranslation);
